import { fetchOtherData } from "./fetchOtherData";

export const cjelineRAR = [
  { value: 1, label: "1. - 3." },
  { value: 2, label: "4. - 6." },
  { value: 3, label: "7. , 8." },
];

export const cjelineOR = [
  { value: 1, label: "1., 2." },
  { value: 2, label: "3., 4." },
  { value: 3, label: "5., 6." },
];

export const programByModule = [
  {
    id: 1,
    moduleIds: [49, 50, 51, 52, 53, 54, 55, 56],
  },
  {
    id: 2,
    moduleIds: [57, 58, 59, 60, 61, 62, 63, 64],
  },
  {
    id: 3,
    moduleIds: [1, 2, 3, 4, 5, 6],
  },
  {
    id: 4,
    moduleIds: [13, 14, 15, 16, 17, 18],
  },
  {
    id: 5,
    moduleIds: [25, 26, 27, 28, 29, 30],
  },
  {
    id: 6,
    moduleIds: [37, 38, 39, 40, 41, 42],
  },
  {
    id: 7,
    moduleIds: [7, 8, 9, 10, 11, 12],
  },
  {
    id: 8,
    moduleIds: [19, 20, 21, 22, 23, 24],
  },
  {
    id: 9,
    moduleIds: [31, 32, 33, 34, 35, 36],
  },
  {
    id: 10,
    moduleIds: [43, 44, 45, 46, 47, 48],
  },
];

export const handlePolaznikSelect = (selectedValue, setSelectedPolaznik) => {
  setSelectedPolaznik(selectedValue);
};

export const handleCjelinaSelect = (selectedValue, setSelectedCjelina) => {
  setSelectedCjelina(selectedValue);
};
export const programOffsetsOne = {
  1: 1,
  3: 9,
  4: 15,
  5: 21,
  6: 27,
  2: 33,
  7: 41,
  8: 47,
  9: 53,
  10: 59,
};
export const programOffsetsTwo = {
  1: 4,
  3: 11,
  4: 17,
  5: 23,
  6: 29,
  2: 36,
  7: 43,
  8: 49,
  9: 55,
  10: 61,
};
export const programOffsetsThree = {
  1: 7,
  3: 13,
  4: 19,
  5: 25,
  6: 31,
  2: 39,
  7: 45,
  8: 51,
  9: 57,
  10: 63,
};

export const getInstrospectionId = (programOffsets, groupData, index) => {
  const result =
    programOffsets[groupData?.programId] !== undefined
      ? index + programOffsets[groupData?.programId]
      : null;

  return result;
};
export const refetchIntrospections = async (
  selectedPolaznik,
  authToken,
  setIntrospections,
  groupData,
  setIsLoading
) => {
  if (selectedPolaznik && authToken) {
    await fetchOtherData(
      selectedPolaznik,
      authToken,
      setIntrospections,
      groupData,
      setIsLoading
    );
  }
};
